<script lang="ts">
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';

	export let dayChange: number = 0;
	export let dark: boolean;
	export let type: 'currency' | 'percentage' | 'decimal' = 'percentage';
	export let border10: boolean = false;

	$: currencyData = $activeCurrency;
	$: value = getValue(dayChange);

	let isPriceIncreased;

	function getValue(change: number) {
		let valueDecimal = (dayChange * currencyData.price).toLocaleString('en-EN', { style: 'decimal' });
		isPriceIncreased = change > 0;
		let valueToShow;
		if (type === 'percentage') {
			valueToShow = `${isPriceIncreased ? '+' : ''}${dayChange.toFixed(2)} %`;
		}
		if (type === 'currency') {
			valueToShow = `${isPriceIncreased ? '+' : ''}${formatNumber(dayChange, currencyData.currency)}`;
		}
		if (type === 'decimal') {
			valueToShow = valueDecimal;
		}
		return valueToShow;
	}
</script>

<div class={`${$$props.class} center wrapper`} class:dark class:border10>
	{#if dayChange > 0}
		<p class={`price-change up`}>{value}</p>
	{:else if dayChange < 0}
		<p class={`price-change down`}>{value}</p>
	{:else}
		<p class={`price-change no-change`}>{value}</p>
	{/if}
</div>

<style lang="scss">
	@import 'percentageChange';
</style>
